import React, { useState } from "react";
import {
  Button,
  Grid,
  Typography,
  TableBody,
  Table,
  TableContainer,
  TablePagination,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { actions } from "../redux/actions/alert";
import styles from "../styles/global-styles";
import ProductTableToolbar from "../components/shared/table/ProductTableToolbar";
import { headCellDistributionBySite } from "../components/stateless/headTables/HeadCellDistributionBySite";
import TableHeadProduct from "../components/shared/table/TableHeadProduct";
import DistributionBySiteTableBody from "../components/shared/table/DistributionBySiteTableBody";
import { changeRowsPerPage } from "../_utils/utils";
import AcceptDistributionProduct from "../components/core/modals/AcceptDistributionProduct";
import { clickCheckbox, selectAllCheckbox } from "../_utils/checkBox";
import HeaderDistribution from "../components/core/distribution/HeaderDistribution";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  label: styles.label,
  table: {
    minWidth: 700,
  },
  form: {
    width: "auto", // Fix IE 11 issue.
    height: 280,
    marginTop: theme.spacing(1),
  },
  formControl: {
    marginTop: theme.spacing(5),
    [theme.breakpoints.down("md")]: {
      width: 180,
    },
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    minWidth: 200,
    width: 320,
  },
  customSelect: styles.customSelect,
  subtitle: styles.subtitle,
  row: styles.rowHover,
}));

const ContainerDistributionsBySite = ({ addAlert, detailAlert }) => {
  const classes = useStyles();
  const [distributionsArray, setDistributionsArray] = useState([]);
  const [openModal, setopenModal] = useState(false);
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  /**Check box options */
  const [selected, setSelected] = useState([]);

  const handleClickCheckbox = (event, distributionId, statusDistributionId) => {
    if (statusDistributionId === 2) {
      console.log("no hacer check");
      return;
    }
    setSelected(clickCheckbox(distributionId, selected));
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleAcceptDistribution = (result) => {
    const { success, message } = result;
    addAlert({ showAlert: true });
    setSelected([]);
    if (success) {
      setTimeout(() => window.location.reload(), 3000);
      detailAlert({ severity: "success", message, time: 2800 });
    } else {
      console.log("message", message);
      detailAlert({ severity: "error", message });
    }
    setopenModal(false);
  };

  const handleDistributionsFiltered = (result, isSuccess) => {
    if (isSuccess) {
      console.log("RESULT handleDistributionsFiltered", result);
      setPage(0);
      setDistributionsArray(result);
    } else {
      console.log("ERROR handleDistributionsFiltered", result);
      addAlert({ showAlert: true });
      detailAlert({
        severity: result.noData || result.dateError ? "warning" : "error",
        message: result.noData || result.dateError,
      });
    }
  };
  return (
    <>
      <HeaderDistribution
        title="Mis distribuciones"
        distributionsfiltered={handleDistributionsFiltered}
        isGlobalDistribution={false}
      />

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
        style={{ margin: "10px, 0" }}
      >
        <Grid item>
          <Button
            className={classes.rightButton}
            onClick={() => setopenModal(true)}
            variant="contained"
            disabled={!selected.length}
            color="primary"
            endIcon={<CheckCircleIcon color="secondary" />}
          >
            Actualizar estatus
          </Button>
        </Grid>
      </Grid>

      <ProductTableToolbar
        productsSelected={selected}
        title={""}
        label={" Distribucion(s) seleccionadas"}
      />
      <TableContainer>
        {distributionsArray.length > 0 ? (
          <Table
            className={classes.table}
            size={"medium"}
            aria-label="customized table"
          >
            <TableHeadProduct
              numSelected={selected.length}
              headCells={headCellDistributionBySite}
              onSelectAllClick={(e) =>
                setSelected(selectAllCheckbox(e, distributionsArray, "product"))
              }
              rowCount={distributionsArray.length}
            />
            <TableBody>
              <DistributionBySiteTableBody
                distributionsArray={distributionsArray}
                page={page}
                rowsPerPage={rowsPerPage}
                distributionSelected={handleClickCheckbox}
                selectedExam={selected}
              />
            </TableBody>
          </Table>
        ) : (
          <Typography
            variant="h6"
            component="h4"
            style={{ marginTop: 50 }}
            className={classes.subtitle}
          >
            Seleccionar filtros para obtener las distribuciones
          </Typography>
        )}
      </TableContainer>
      {distributionsArray.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={distributionsArray.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={(event) => {
            const { rowsPerPage, page } = changeRowsPerPage(event);
            setRowsPerPage(rowsPerPage);
            setPage(page);
          }}
        />
      )}

      {openModal && (
        <AcceptDistributionProduct
          open={openModal}
          onClose={() => setopenModal(false)}
          idsSelected={selected}
          distributionAccepted={handleAcceptDistribution}
        />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ContainerDistributionsBySite);
